import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {fetchList} from '../actions/index';

import Search from './Search';
import Filter from './Filter';
import ThreadList from './ThreadList';

/** The Viewer component is the brains of the application
  and handles all of the API calls whenever the location
  props have changed. */
class Viewer extends Component {
  /** @inheritdoc */
  constructor(props) {
    super(props);

    this.fetchContent = this.fetchContent.bind(this);
  }

  /**
   * Before the component mounts, if the user hasn't selected a filter we
   * automatically re-direct them to the default, 'hot'. Because the Reddit API
   * lets you query dummy data which returns nothing we strip out any search params here as it can
   * cause problems when it doesn't know what page 1 is.
   * @returns {undefined}
   */
  componentWillMount() {
    if (!this.props.params.filter) {
      this.context.router.push(`/r/${this.props.params.sub}/hot`);
    } else if (this.props.params.filter && this.props.location.search !== '') {
      this.context.router.push(
        `/r/${this.props.params.sub}/${this.props.params.filter}/`
      );
    }
  }

  /**
   * When the component mounts an API call is made based on the filter in the query params.
   * If the filter doesn't exist we default to 'hot, the Reddit standard.
   * @returns {undefined}
   */
  componentDidMount() {
    if (this.props.params.filter) {
      this.fetchContent(this.props.params.sub, this.props.params.filter, '');
    } else {
      this.fetchContent(this.props.params.sub, 'hot', '');
    }
  }

  /**
   * Makes sure that when the route props update that it's not updating content
   * for no reason. Three criteria are checked within this method.
   * @param {Object} nextProps - The next props that the component will receive.
   * @returns {undefined}
   */
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.params.filter !== this.props.params.filter ||
      nextProps.params.sub !== this.props.params.sub ||
      nextProps.location.search !== this.props.location.search
    ) {
      this.fetchContent(
        nextProps.params.sub,
        nextProps.params.filter,
        nextProps.location.search
      );
    }
  }

  /**
   * Fires off an action creator that fetches data from the Reddit API.
   * @param {string} sub - The subreddit name, for example 'cats'.
   * @param {string} filter - The filter which will be queried, for instance 'new'.
   * @param {string} search - Any additional filtering, such as 'All Time'.
   * @returns {undefined}
   */
  fetchContent(sub, filter, search) {
    this.props.fetchList(`${sub}/${filter}`, search);
  }

  /**
   * Renders the Viewer component.
   * @returns {string} JSX representation of the component.
   */
  render() {
    return (
      <div>
        <Search
          className="col s6"
          params={this.props.params}
          location={this.props.location}
        />
        <Filter
          className="col s6"
          params={this.props.params}
          location={this.props.location}
        />
        <ThreadList {...this.props} />
      </div>
    );
  }
}

/**
 * Maps Redux application state to props.
 * @param {string} state - Application state handed down by Redux.
 * @returns {Object} - Returns an object containing the Redux state.
 */
function mapStateToProps(state) {
  return {
    threads: state.threads.list,
    toast: state.threads.toast,
  };
}

Viewer.contextTypes = {
  router: PropTypes.object,
};

export default connect(
  mapStateToProps,
  {fetchList}
)(Viewer);



// WEBPACK FOOTER //
// ./src/components/Viewer.js